import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';
import { Box, CircularProgress, Typography, Button } from '@mui/material';

const Callback = () => {
  const { isAuthenticated, loginWithRedirect } = useAuth0();
  const navigate = useNavigate();
  const location = useLocation();
  
  // Check if there's an error in the URL
  const params = new URLSearchParams(location.search);
  const error = params.get('error');
  const errorDescription = params.get('error_description');

  useEffect(() => {
    // Tarkistetaan onko URL:ssa koodi mutta ei virhettä
    const code = params.get('code');
    
    if (code && !error) {
      // Jos koodi löytyy, ohjataan käyttäjä kotisivulle
      console.log('Auth0 koodi löytyi, ohjataan etusivulle...');
      navigate('/');
    } else if (isAuthenticated) {
      // Jos käyttäjä on jo autentikoitu, ohjataan kotisivulle
      navigate('/');
    }
  }, [isAuthenticated, navigate, params, error]);

  // If there's an error, show it
  if (error) {
    return (
      <Box sx={{ 
        display: 'flex', 
        flexDirection: 'column',
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        padding: 3,
        textAlign: 'center'
      }}>
        <Typography variant="h5" color="error" gutterBottom>
          Kirjautumisvirhe
        </Typography>
        <Typography variant="body1" gutterBottom>
          {errorDescription || 'Kirjautuminen epäonnistui. Yritä uudelleen.'}
        </Typography>
        <Button 
          variant="contained" 
          color="primary" 
          sx={{ mt: 3 }}
          onClick={() => {
            // Ohjaa suoraan Auth0-kirjautumiseen ohittaen SDK:n välimuistin
            const domain = 'dev-ppy1fc543jivoo30.us.auth0.com';
            const clientId = '0SB2iycAdWVlPY6a9par0fe476lA5B71';
            const redirectUri = encodeURIComponent(`${window.location.origin}/callback`);
            const audience = encodeURIComponent('https://api.purkuapp.fi');
            
            // Lisätään aikaleima estämään välimuistin käyttöä
            const timestamp = new Date().getTime();
            
            // Rakennetaan URL suoraan pakottaen käyttäjätunnus/salasana -kirjautuminen
            const url = `https://${domain}/authorize?client_id=${clientId}&response_type=code&redirect_uri=${redirectUri}&audience=${audience}&scope=openid%20profile%20email&connection=Username-Password-Authentication&prompt=login&login_hint=testipurkupojat@testi.fi&cache=${timestamp}`;
            
            // Ohjataan suoraan kirjautumissivulle
            window.location.href = url;
          }}
        >
          Yritä uudelleen
        </Button>
      </Box>
    );
  }

  // Otherwise show loading spinner
  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
      <CircularProgress />
    </Box>
  );
};

export default Callback;
